import React, { Component } from 'react';

import localization from '@progressivebeef/shared/src/localization/i18n';
import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';

import AppContainer from '../AppContainer';
import PBIcon from '../PBIcon';
import withRouter from '../../routes/withRouter';
import './style.scss';

class VideoPlayer extends Component {
  renderLeftHeader = () => {
    return (
      <div className="head-icon left-align">
        <PBIcon
          name={'chevron-left'}
          onPress={() => this.props.history.goBack()}
        />
      </div>
    );
  };

  render() {
    const { history, location } = this.props;
    
    // Safety check for location.state
    if (!location || !location.state) {
      return (
        <AppContainer
          iconHeader
          history={history}
          IconLeftHeader={this.renderLeftHeader}
          noncollapsible
          title={localization[getLocale()].NAVIGATION_VIDEOS}
        >
          <div className="training-video-play-screen">
            <p>Video not available</p>
          </div>
        </AppContainer>
      );
    }

    const { file, english, spanish } = location.state;

    return (
      <AppContainer
        iconHeader
        history={history}
        IconLeftHeader={this.renderLeftHeader}
        noncollapsible
        title={localization[getLocale()].NAVIGATION_VIDEOS}
      >
        <div className="training-video-play-screen">
          <video
            className="x-media videoPlayer"
            id="video"
            controls={true}
            autoplay="autoplay"
          >
            <source src={file} />
            {getLocale() == 'en' ? (
              <track
                label="English"
                kind="subtitles"
                srclang="en"
                src={english}
                default
              ></track>
            ) : (
              <track
                label="Espanol"
                kind="subtitles"
                srclang="es"
                src={spanish}
                default
              ></track>
            )}
          </video>
        </div>
      </AppContainer>
    );
  }
}

export default withRouter(VideoPlayer);
